<template>
  <div class="list-form-pagination">
    <div class="list-form-pagination__sizes">
      <span class="list-form-pagination__title">{{L10n('page-size')}}</span>
      <el-select
        :value="config.size"
        @change="handlerChangeSize"
      >
        <el-option
          v-for="(size, i) in config.sizes.values"
          :key="i"
          :value="size.value"
          :label="size.label"
        ></el-option>
      </el-select>
      <span class="list-form-pagination__title">{{L10n('total')}}: {{config.total}}</span>
    </div>
    <el-pagination
      layout="pager"
      :hide-on-single-page="true"
      :pager-count="5"
      :current-page.sync="config.current"
      :page-size="config.size"
      :total="config.total"
      @current-change="handlePagination"
    />
  </div>
</template>

<script>
export default {
  name: 'ListFormPagination',
  props: {
    config: { type: Object, required: true }
  },
  methods: {
    handlerChangeSize (value) {
      let { size, current } = this.config
      let start = (size * (current - 1))
      let newCurrent = Math.ceil(start / value - 1)
      newCurrent = Math.max(1, newCurrent)
      this.$emit('on-pagination', {
        size: value,
        current: newCurrent
      })
    },
    handlePagination (page) {
      this.$emit('on-pagination', {
        current: page
      })
    }
  }
}
</script>
<style lang="stylus">
  .list-form-pagination{
    margin 1.5rem
    display flex
    align-items center
    justify-content space-between
    .el-pagination{
      padding 0
      .el-pager{
        margin 0
      }
      .el-pager li {
        font-size 1.2rem
        font-weight bold
        color #65646c
        border-radius 0
        padding 0
        margin 0 0.2rem
        min-width 3rem
        line-height 3rem
        padding-left 1rem
        padding-right 1rem
        background none
        border 0
        transition all 0.3s ease
        &.active{
          color #09729b
          background none
          box-shadow none
          border 1px solid #c7dde7
          border-radius 0.5rem
        }
        &:hover{
          color #09729b
          background none
          box-shadow none
          border 1px solid #65646c
          border-radius 0.5rem
        }
      }
    }
  }
  .list-form-pagination__title{
    color #65646c
    font-size 1.2rem
    line-height 2.8rem
    text-align center
    vertical-align center
  }
  .list-form-pagination__sizes{
    display flex
    .el-select{
      width 10rem
      margin 0 1rem
    }
    .el-input__inner{
      height 3rem
      line-height 2.8rem
      font-size 1.2rem
      font-weight bold
    }
    .el-input__icon{
      line-height 2.8rem
    }
  }
</style>
